module.exports = __webpack_public_path__ + "img/chevron-left.2c1ec14e.svg";